/*=============================================== Footer component ===============================================*/

import { ButtonIcon, capitalize } from "tsx-library-julseb"

import { StyledFooter } from "./styles"

import { siteData } from "data"

const Footer = () => {
    const links: FooterLinkType[] = [
        {
            icon: "github",
            to: siteData.githubRepo,
            blank: true,
        },
        {
            icon: "npm",
            to: siteData.npmRepo,
            blank: true,
        },
        {
            icon: "mail",
            to: `mailto:${siteData.email}`,
        },
        {
            icon: "portfolio",
            to: siteData.portfolio,
            blank: true,
        },
    ]

    return (
        <StyledFooter>
            {links.map(({ icon, to, blank }) => (
                <ButtonIcon
                    icon={icon}
                    href={to}
                    blank={blank}
                    label={icon !== "npm" ? capitalize(icon) : icon}
                    showLabel={{
                        bottom: 40,
                    }}
                    size={32}
                    variant="transparent"
                    key={icon}
                />
            ))}
        </StyledFooter>
    )
}

export default Footer

type FooterLinkType = {
    icon: string
    to: string
    blank?: boolean
}
